import { restApi } from '../services/api';

export const systemParametersRepository = {
  getBrand: () => restApi.get('brands/system-parameters/system-brand'),
  getGlobal: () => restApi.get('brands/system-parameters/system-global'),
  getStore: () => restApi.get('stores/system-parameters/system-store'),
  getStoreBrandsAggregated: () =>
    restApi.get('stores/system-parameters/system-store/brands-aggregated'),
};
